import React from 'react';
import { UserIcon } from '@heroicons/react/24/solid';
import { ProfilePhotoProps } from './types';

const ProfilePhoto: React.FC<ProfilePhotoProps> = ({
  photoUrl,
  previewPhotoUrl,
  onPhotoChange,
  isEditing = false,
  userName = '',
}) => {
  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0] && onPhotoChange) {
      onPhotoChange(e.target.files[0]);
    }
  };

const displayPhotoUrl = previewPhotoUrl || photoUrl;
const initials = userName
  .split(' ')
  .map((word) => word.charAt(0).toUpperCase())
  .join('')
  .slice(0, 2);

if (!isEditing) {
  return (
    <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden mb-4 border-4 border-white shadow-lg bg-gradient-to-br from-blue-400 to-blue-600">
      {displayPhotoUrl ? (
        <img
          src={displayPhotoUrl}
          alt="Profile"
          className="w-full h-full object-cover"
          // Fix: Add this line to bypass Google's referrer block
          referrerPolicy="no-referrer"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-white">
          {initials ? (
            <span className="text-3xl md:text-5xl font-bold">{initials}</span>
          ) : (
            <UserIcon className="w-16 h-16 md:w-24 md:h-24 text-white opacity-80" />
          )}
        </div>
      )}
    </div>
  );
}

  // Edit mode - photo with upload functionality
  return (
    <div className="mb-6 text-center md:text-left">
      <label className="block text-gray-700 font-semibold mb-2 text-sm md:text-base">
        Profile Photo
      </label>
      <div className="flex flex-col md:flex-row items-center md:items-start">
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden mb-3 md:mb-0 md:mr-4 bg-gradient-to-br from-blue-400 to-blue-600">
          {displayPhotoUrl ? (
            <img
              src={displayPhotoUrl}
              alt="Profile Preview"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-400 to-blue-600">
              {initials ? (
                // Show initials if available
                <span className="text-3xl md:text-5xl font-bold text-white">{initials}</span>
              ) : (
                // Show default user icon if no initials
                <UserIcon className="w-16 h-16 md:w-24 md:h-24 text-white opacity-80" />
              )}
            </div>
          )}
        </div>
        <input
          type="file"
          accept="image/*"
          onChange={handlePhotoChange}
          className="hidden"
          id="photo-upload"
        />
        <label
          htmlFor="photo-upload"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 cursor-pointer text-sm md:text-base mt-2 md:mt-0"
        >
          {photoUrl ? 'Change Photo' : 'Choose Photo'}
        </label>
      </div>
    </div>
  );
};
export default ProfilePhoto;
